<template lang="pug">
    v-dialog(v-model="dialog" persistent max-width="400")
        v-card(class="menu")
            v-toolbar(flat justify-end text-right)
              v-spacer
              v-toolbar-title(class="font-weight-bold primary--text mr-6") KEAMANAN SYSTEM
              v-icon(class="primary--text" class="mx-4") mdi-shield-account
            v-card-text(class="font-weight-medium text-center mt-2" )
              v-layout
                v-flex(lg3 md3 xs3) 
                  v-icon(class="primary--text" large) mdi-shield-account
                v-flex(lg9 md9 xs9) 
                  div(v-if="!success") Anda masih menggunakan user default
                  div(v-if="!success") Silahkan lakukan perubahan username dan password
                  div(v-if="success") Silahkan login kembali dengan username dan password baru anda
            v-card-text(v-if="!success")
              v-form(ref="first" id="first" @submit.prevent="doOK" lazy-validation)
                v-layout(wrap class="mx-6")
                  v-flex(lg12 md12 xs12)
                      v-text-field(dense v-model="item.newUsername" label="Username" :rules="[v => !!v || 'Input username', v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{5,15})/.test(v) || 'Username terdiri 5-15 huruf besar, kecil dan angka']" prepend-icon="mdi-account-circle" maxlength="15" required)
                      f-passwordbox(v-model="item.newPassword" :rules="[v => !!v || 'Masukan password', v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(v) || 'Password minimal 8 karakter alphanumeric']" label="Password" :required="true" )
                      f-passwordbox(v-model="item.confirmPassword" :rules="[v => !!v || 'Masukan konfirmasi password', confirmMatch || 'Password baru dan konfirmasi password tidak sesuai']" label="Konfirmasi Password" :required="true" )
            v-card-actions(class="justify-center")
              v-btn(v-if="!success" class="mb-3" color="primary" type="submit" form="first" width="150px" style="font-size:10px") Lanjutkan
                v-icon(small) mdi-shield-account
              v-btn(v-if="success" class="mb-3" @click="doLogout" width="150px" style="font-size:10px") Keluar
                  v-icon(small) mdi-logout-variant
</template>
<script>
export default {
  name: "FDialogFirstLogin",
  props: ["username", "value"],
  watch: {
    value(val) {
      this.doInitModel(val);
    }
  },
  mounted() {
    this.doInitModel(this.value);
  },
  data() {
    return {
      dialog: false,
      success: false,
      confirmMatch: true,
      item: {
        username: "",
        confirmPassword: "",
        newUsername: "",
        newPassword: ""
      }
    };
  },
  methods: {
    doInitModel(values) {
      this.dialog = values ? values : "";
    },
    doOK() {
      if (this.$refs.first.validate()) {
        if (this.item.newPassword != this.item.confirmPassword) {
          this.confirmMatch = false;
        } else {
          this.item.username = this.username;
          this.$progress.show(true);
          this.$http.post("/api/user/first-login", this.item).then(
            success => {
              this.success = true;
            },
            err => {
              this.$message.error(err.response.data.message);
            }
          ).finally(() => this.$progress.show(false));
        }
      }
    },
    doLogout() {
      this.dialog = false;
      this.$progress.show(true);
      this.$http.get("/api/sec/logout", {params: {username: this.username}}).then(
        success => {
          this.$session.clear();
          if(this.$socket.isStarted()){
            this.$socket.deactivate();
          } 
          
          this.$router.push({ name: "login" }).catch(err => {});
        },
        err => {
          this.$session.clear();
          if(this.$socket.isStarted()){
            this.$socket.deactivate();
          } 
          
          this.$router.push({ name: "login" }).catch(err => {});
        }
      ).finally(() => this.$progress.show(false), this.closeDialog());
    },
    closeDialog(){
      this.dialog = false;
      this.$emit("dialog", false);
    }
  }
};
</script>

